import { useState, useCallback } from 'react';

export default function useTableDataParams(defaults) {
  const [tableDataParams, setTableDataParams] = useState({
    pageSize: 25,
    currentPage: 1,
    sorts: [{ column: 'Id', asc: true }],
    filters: [],
    quickFilters: [],
    search: '',
    ...defaults,
  });

  const updateTableDataParams = useCallback(newTableDataParams => {
    setTableDataParams(prevParams => ({ ...prevParams, ...newTableDataParams }));
  }, []);
  return [tableDataParams, updateTableDataParams];
}
